import React, { useRef, useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { collection, addDoc, getDocs } from 'firebase/firestore';
import { db } from './firebaseConfig';
import { SiweMessage } from 'siwe';
import { checksumAddress } from 'viem';


const CreateArtistProfile = ( {provider} ) => {
  const nameRef = useRef();
  const genreRef = useRef();
  const avatarRef = useRef();
  const addressRef = useRef();
  const [userAddress, setUserAddress] = useState('');

  useEffect(() => {
    const getUserAddress = async () => {
      try {
        const addresses = await provider.request({ method: 'eth_requestAccounts' });
        setUserAddress(checksumAddress(addresses[0]));  // Checksum the address
      } catch (error) {
        console.error('Error getting user address:', error);
        toast.error('Please connect your wallet');
      }
    };

    getUserAddress();
  }, [provider]);

  const generateUniqueId = async () => {
    const querySnapshot = await getDocs(collection(db, 'artists'));
    const artistIds = querySnapshot.docs.map(doc => doc.data().id);
    let newId = 1;
    while (artistIds.includes(newId)) {
      newId += 1;
    }
    return newId;
  };

  const signInWithEthereum = async (provider) => {
    try {
      const message = new SiweMessage({
        domain: window.location.host,
        address: userAddress, // Normalize the case of the address
        statement: 'Sign in with Ethereum to the application.',
        uri: window.location.origin,
        version: '1',
        chainId: 1,
      });

      const messageToSign = message.prepareMessage();
      const signature = await provider.request({
        method: 'personal_sign',
        params: [messageToSign, userAddress],
      });

      const recoveredAddress = await message.recoverAddress(signature);
      if (recoveredAddress.toLowerCase() !== userAddress.toLowerCase()) {
        throw new Error('Address mismatch');
      }

      return true;
    } catch (error) {
      console.error('Error during SIWE sign-in:', error);
      toast.error('Sign-In with Ethereum failed.');
      return false;
    }
  };

  const createArtist = async (name, genre, avatar, address) => {
    try {

      if (!name || !genre || !avatar || !address ) {
        toast.error('Please fill in all fields');
        return;
      }
      toast.info('Saving creator profile...');
     

      const isAuthenticated = await signInWithEthereum(provider);

      if (!isAuthenticated) {
        toast.error('Sign In With Ethereum Failed')
        return;
      }

      const artistId = await generateUniqueId();

      const artistData = {
        id: artistId,
        name,
        genre,
        address,
        avatar,
        tiers: [],
      };

      await addDoc(collection(db, 'artists'), artistData);

      toast.success('Creator profile created successfully!');
      window.location.href = '/dapp/artists/content';
    } catch (error) {
      console.error('Error creating artist:', error);
      if (error.message === 'Ethereum provider not available') {
        toast.error('Ethereum provider not available. Please ensure your wallet is connected.');
      } else {
        toast.error('Failed to create creator profile.');
      }
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <ToastContainer />
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Create Profile</h2>
        <div className="flex flex-col gap-4">
          <input
            ref={nameRef}
            type="text"
            placeholder="Name"
            className="block w-full mb-4 px-4 py-2 bg-gray-700 rounded-lg"
          />
          <input
            ref={genreRef}
            type="text"
            placeholder="Genre or Work Title"
            className="block w-full mb-4 px-4 py-2 bg-gray-700 rounded-lg"
          />
          <input
            ref={addressRef}
            type="text"
            placeholder="Wallet Address"
            value={userAddress}
            readOnly
            className="block w-full mb-4 px-4 py-2 bg-gray-700 rounded-lg"
          />
          <input
            ref={avatarRef}
            type="text"
            placeholder="Avatar URL"
            className="block w-full mb-4 px-4 py-2 bg-gray-700 rounded-lg"
          />
        </div>
        <button
          className="px-4 py-2 bg-green-600 rounded-lg text-white mt-4"
          onClick={() =>
            createArtist(
              nameRef.current.value,
              genreRef.current.value,
              avatarRef.current.value,
              addressRef.current.value
            )
          }
        >
          Creator Sign Up
        </button>
      </div>
    </div>
  );
};

export default CreateArtistProfile;
